import styled from 'styled-components';
import { COLORS, breakPoint } from '@ertelecom/ui-react/assets/js/constants';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton';
import Checkbox from '@ertelecom/ui-react/components/controls/checkbox';

export const PackageInfo = styled.div`
    display: flex;
    width: 100%;
    border-bottom: 1px solid ${COLORS.outlineGrey};
    padding-bottom: 26px;
    align-items: center;
    margin-bottom: 20px;
`;

export const HDCount = styled.span`
    color: ${COLORS.black};
    font: 300 20px/28px "Roboto", sans-serif;
`;

export const Price = styled.div`
    margin-left: auto;
    display: flex;
    align-items: center;
`;

export const PriceCount = styled.span`
    color: ${COLORS.black};
    font: 400 20px/28px "Roboto", sans-serif;
`;

export const PriceUnit = styled.span`
    color: ${COLORS.black};
    font: 400 14px/18px "Roboto", sans-serif;
    margin-left: 5px;
`;

export const StyledCheckbox = styled(Checkbox)`
    margin-top: 20px;
    display: flex;
    align-items: center;

    @media(${breakPoint(768)}) {
        max-width: 82%;
    }

    @media(${breakPoint(320)}) {
        max-width: 100%;
        font-size: 16px;
        line-height: 24px;
        align-items: flex-start;
    }
`;

export const Controls = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    margin-top: 40px;
    width: 100%;

    @media(${breakPoint(320)}) {
        flex-direction: column;
    }
`;

export const ControlsCenter = styled(Controls)`
    justify-content: center;
    margin-top: 40px;
`;

export const ButtonBack = styled.button`
    appearance: none;
    font: 400 16px/26px "Roboto", sans-serif;
    color: ${COLORS.blue};
    padding: 0;
    border: none;
    border-bottom: 1px dashed ${COLORS.blue};
    display: inline-block;
    background: none;
    flex-shrink: 0;
    outline: none;
    cursor: pointer;
`;

export const Button = styled(StyledButton)`
    flex-shrink: 0;
    max-width: 184px;

    & + ${ButtonBack} {
        margin-left: 35px;

        @media(${breakPoint(320)}) {
            margin-left: 0;
            margin-top: 20px;
        }
    }
`;

export const Icon = styled.img`
    display: block;
    width: 49px;
    height: 49px;
    margin: 0 auto 16px;
`;

export const CenterBlock = styled.div`
    text-align: center;
    width: 100%;
`;

export const Text = styled.p`
    font: 300 16px/24px "Roboto", sans-serif;
    color: ${COLORS.darkGrey};
`;

export const Title = styled.h3`
    font: 300 20px/28px "Roboto", sans-serif;
    color: ${COLORS.black};
    width: 100%;

    & + ${Text} {
        margin-top: 13px;
    }
`;
